import React from "react";
import "./Onboarding.css";

function OnboardingSuccess() {
  return (
    <div className="onboarding-success">
      <h2>🎉 You're All Set!</h2>
      <p>Thanks for submitting your onboarding details.</p>
      <p>We'll review everything and reach out shortly with next steps.</p>
    </div>
  );
}

export default OnboardingSuccess;
